import { FadeUp } from '../motion';
import { useT } from '../../i18n/LangContext';

const LOGOS = [
  { name: 'The Home Depot', src: '/partners/home-depot.png' },
  { name: 'Sherwin-Williams', src: '/partners/sherwin-williams.png' },
  { name: 'Staples', src: '/partners/staples.png' },
  { name: 'Dulux', src: '/partners/dulux.png' },
  { name: 'Canadian Tire', src: '/partners/canadian-tire.png' },
  { name: 'Best Buy', src: '/partners/best-buy.png' },
];

export default function Partners() {
  const t = useT();

  return (
    <section data-testid="partners-section" className="border-y border-black/10 bg-white py-16 text-ink">
      <div className="container-site">
        <FadeUp>
          <p className="text-center text-xs font-bold uppercase tracking-[0.3em] text-neutral-400">{t['pt.label']}</p>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-x-14 gap-y-8">
            {LOGOS.map((logo) => (
              <img key={logo.name} src={logo.src} alt={logo.name} loading="lazy"
                data-testid={`partner-${logo.name.toLowerCase().replace(/[^a-z]/g, '-')}`}
                className="h-12 w-auto object-contain grayscale opacity-60 transition-[filter,opacity,transform] duration-500 hover:-translate-y-1 hover:opacity-100 hover:grayscale-0 md:h-16" />
            ))}
          </div>
        </FadeUp>
      </div>
    </section>
  );
}
